import { Builder } from '@builder.io/react'
import { IncentiveThreeColumnWithHeader } from './IncentiveThreeColumnWithHeader'

Builder.registerComponent(IncentiveThreeColumnWithHeader, {
  name: '3-column with illustrations and header',
  image:
    'https://cdn.builder.io/api/v1/image/assets%2FYJIGb4i01jvw0SRdL5Bt%2Fd3fad4746b794e59a7bc6ba502ec4f44',
  inputs: [
    {
      name: 'sectionTitle',
      type: 'string',
      defaultValue: 'We built our business on great customer service',
    },
    {
      name: 'sectionDescription',
      type: 'string',
      defaultValue: `At the beginning at least, but then we realized we could make a lot more money if we kinda stopped caring about that. Our new strategy is to write a bunch of things that look really good in the headlines, then clarify in the small print but hope people don't actually read it.`,
    },
    {
      name: 'incentives',
      type: 'list',
      subFields: [
        { name: 'name', type: 'string', defaultValue: 'Free shipping' },
        {
          name: 'description',
          type: 'string',
          defaultValue: `It's not actually free we just price it into the products. Someone's paying for it, and it's not us.`,
        },
        {
          name: 'imageSrc',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
          required: true,
          defaultValue: 'https://tailwindui.com/img/ecommerce/icons/icon-shipping-simple.svg',
        },
      ],
    },
  ],
})
